<template>
  <div class="int-picker">
    <div class="int-picker--increment">
      <div class="dt-icon-container">
        <img
          @click="onIncrement"
          src="static/icons/chevron-up-blue.svg"
          alt="Down Arrow"
          class="dt-icon s1 v5"
        />
      </div>
    </div>
    <div class="int-picker--value">
      {{ valueString }}
    </div>
    <div class="int-picker--decrement">
      <div class="dt-icon-container">
        <img
          @click="onDecrement"
          src="static/icons/chevron-down-blue.svg"
          alt="Down Arrow"
          class="dt-icon s1 v5"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    max: {
      type: Number,
    },
    numbers: {
      type: Array,
    },
  },
  computed: {
    valueString() {
      return this.value ? `${this.value}`.padStart(2, "0") : "00";
    },
  },
  methods: {
    format(value) {
      return `${value}`.padStart(2, "0");
    },
    onIncrement() {
      this.$emit("changed", +this.value + 1);
    },
    onDecrement() {
      this.$emit("changed", +this.value - 1);
    },
  },
};
</script>

<style lang="scss">
.int-picker {
  margin: 4px;
  &--value {
    text-align: center;
  }
}
</style>